var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSupportIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.5,
    height: 16,
    viewBox: "0 0 17.5 16",
    id: "support-consumption-small",
    "data-supported-dps": "16x16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "reactions-support-consumption-small-a",
    x: 0,
    y: 0,
    width: 17.5,
    height: 16,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 15a7 7 0 10-7-7 7 7 0 007 7z",
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#reactions-support-consumption-small-a)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 15a7 7 0 10-7-7 7 7 0 007 7z",
    fill: "#d8d8d8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 15a7 7 0 10-7-7 7 7 0 007 7z",
    fill: "#bba9d1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.55 10.62h-.21c-.23-.09-1.38-.53-2.15-.74A.25.25 0 014 9.67a.67.67 0 01.11-.5.39.39 0 01.34-.17.69.69 0 01.2 0 1.79 1.79 0 01.42.25l.36.25.33.24.84.33c.11 0 .58.26.55.38s-.53.11-.64.11z",
    fill: "#fef2ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.47 14.07a23.68 23.68 0 01-3.56-.33h-.06a21.22 21.22 0 01-2.64-.51c-.77-.22-1.53-.5-2.26-.77l-.33-.12c-.7-.25-1.26-.47-1.77-.67l-.2-.07a9.1 9.1 0 01-.9-.4c-.4-.22-.53-.5-.35-.84A.6.6 0 014 10h.2a21.93 21.93 0 012.86.86h1.19L11 11a5.08 5.08 0 00-2-.8c-.25-.06-.48-.13-.53-.29a.66.66 0 01.24-.72 1.09 1.09 0 01.56-.12 3.27 3.27 0 01.7.08l.36.1a4.25 4.25 0 00.86.18 8.87 8.87 0 011.43.3 2.43 2.43 0 012 1.51c-.06-.18 0-.05 0-.11v-.06h.99c.13 0 .7-.14.7 0a5.45 5.45 0 01-.67 3 .17.17 0 01-.14.1z",
    fill: "#eae2f3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2 10a.09.09 0 00.1 0z",
    fill: "#d67676"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.14 3.57a1.43 1.43 0 00-2 0 1.5 1.5 0 000 2.1L6.3 7.92l2.22-2.25a1.5 1.5 0 000-2.1 1.44 1.44 0 00-2 0l-.17.17z",
    fill: "#ecaa96",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.92 11.25a2.58 2.58 0 01-.13 1.62 5.29 5.29 0 01-1.21 1.69c-.13.12-4.85-.52-6-.69a58.16 58.16 0 01-6.49-2.7c-.21-.11-.22-.9.37-1.06s2.85.8 3.8.88 2.54.18 3.67.18-1.3-.68-1.7-.82-1-.31-1.08-.64S8.63 9 9 9a6.57 6.57 0 012 .35 13.35 13.35 0 012.45.5A3.1 3.1 0 0115 11c.11.2 1.81.17 1.92.25z",
    fill: "none",
    stroke: "#493d57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.07 10.09A.75.75 0 014.59 9c.4-.08 1.18.42 1.72.91a5.73 5.73 0 001.89 1.14",
    fill: "none",
    stroke: "#493d57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.22 3.37A1.58 1.58 0 004 5.6L6.4 8l2.42-2.4a1.59 1.59 0 00.43-1.38 1.54 1.54 0 00-.86-1.15 1.52 1.52 0 00-.69-.16 1.58 1.58 0 00-1.12.47l-.18.17z",
    fill: "none",
    stroke: "#77280c",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupportIcon);
export default __webpack_public_path__ + "static/media/support-icon.4212681ad33f3eafab0d86d07ce9c7c0.svg";
export { ForwardRef as ReactComponent };